export const getFirstIntegration = (
  authInfo: { Integrations?: unknown } | null | undefined
) => {
  const integrations = authInfo?.Integrations;
  if (Array.isArray(integrations) && integrations.length > 0) {
    return integrations[0];
  }
  return null;
};
